import { Form, Input, Checkbox } from "antd";
import { observer } from "mobx-react";
import { __, _i, _x } from "../../../utils";
import { PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM } from ".";
import { PluginUpdateLicenseTelemetryDataModal } from "..";
const PluginUpdateTermFields = observer(_ref => {
  let {
    pluginUpdate
  } = _ref;
  const PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM = {
    ...PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
    zoom: 0.8
  };
  const {
    privacyProvider,
    privacyPolicy,
    allowsTelemetry,
    allowsAutoUpdates,
    allowsNewsletter,
    additionalCheckboxes,
    licenses: [firstLicense]
  } = pluginUpdate;
  return /*#__PURE__*/React.createElement(React.Fragment, null, allowsAutoUpdates && /*#__PURE__*/React.createElement(Form.Item, {
    name: "autoUpdates",
    valuePropName: "checked",
    style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("Updates containing bug fixes and new features will be downloaded and installed automatically."), {
    a: /*#__PURE__*/React.createElement("a", {
      href: privacyPolicy,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    name: "terms",
    valuePropName: "checked",
    required: true,
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the privacy policy!")
    }],
    style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(_x("I allow to transfer technical data about this WordPress installation to the update server of %1$s and get latest announcements. This data is required for license activation and update functionality. I have read the {{a}}privacy policy{{/a}} of %1$s.", "legal-text", privacyProvider), {
    a: /*#__PURE__*/React.createElement("a", {
      href: privacyPolicy,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), allowsTelemetry && /*#__PURE__*/React.createElement(Form.Item, {
    name: "telemetry",
    valuePropName: "checked",
    style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(_x("I allow telemetry data about the use of this WordPress plugin to be collected in accordance with the %1$s {{a}}privacy policy{{/a}}. This data does not include any personal information about users of the plugin. Collected data ({{aDataExample}}open example of transmitted data{{/aDataExample}}) will be used to provide you with the best possible support and to improve the plugin.", "legal-text", privacyProvider), {
    a: /*#__PURE__*/React.createElement("a", {
      href: privacyPolicy,
      target: "_blank",
      rel: "noreferrer"
    }),
    aDataExample: /*#__PURE__*/React.createElement(PluginUpdateLicenseTelemetryDataModal, {
      license: firstLicense,
      linkWrapper: true
    })
  }))), additionalCheckboxes.map(_ref2 => {
    let {
      id,
      text
    } = _ref2;
    return /*#__PURE__*/React.createElement(Form.Item, {
      name: id,
      key: id,
      valuePropName: "checked",
      style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM
    }, /*#__PURE__*/React.createElement(Checkbox, null, text));
  }), allowsNewsletter && /*#__PURE__*/React.createElement(Form.Item, {
    name: "newsletter",
    valuePropName: "checked",
    style: PLUGIN_UPDATE_FORM_LAYOUT_TERM_ITEM
  }, /*#__PURE__*/React.createElement(Checkbox, null, _x("I would like to receive the %1$s newsletter with WordPress news, sales and product offers (approx. 1-2 per month) via email. I know that I can withdraw my consent for the newsletter at any time.", "legal-text", privacyProvider))), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: (prevValues, nextValues) => prevValues.newsletter !== nextValues.newsletter
  }, _ref3 => {
    let {
      getFieldValue
    } = _ref3;
    return getFieldValue("newsletter") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
      label: __("First name"),
      name: "firstName",
      style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
      required: true,
      rules: [{
        required: true,
        message: __("Please enter your first name!")
      }]
    }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
      label: __("Email"),
      name: "email",
      style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
      required: true,
      rules: [{
        type: "email",
        required: true,
        message: __("Please enter your email address!")
      }]
    }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement("div", {
      className: "notice notice-info inline below-h2 notice-alt",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("p", null, __("Please note that we will send you a confirmation e-mail. Only when you have clicked on the activation link in the email will you receive the newsletter."))));
  }));
});
export { PluginUpdateTermFields };